module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-8.a77fec5b.svg";